import { render, staticRenderFns } from "./reciboDePago.vue?vue&type=template&id=3d768f4c&scoped=true&"
import script from "./reciboDePago.vue?vue&type=script&lang=js&"
export * from "./reciboDePago.vue?vue&type=script&lang=js&"
import style0 from "./reciboDePago.vue?vue&type=style&index=0&id=3d768f4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d768f4c",
  null
  
)

export default component.exports